// import customRender from './customRender';
// name: mdEditor
const state = {
  mdEditorId: 'md-editor-id',
  mdEditorToolbars: [
    'save', 0, 'revoke', 'next', 'catalog', '-',
    'bold', 'underline', 'italic', 'image', '-',
    'title', 'strikeThrough', 'sub', 'sup', 'quote',
    'unorderedList', 'orderedList', 'task', '-',
    'codeRow', 'code', 'link', 'table', 'mermaid', 'katex',
  ],
};
const getters = {
  getMdEditorId: (state) => { return state.mdEditorId; },
  getMdEditorToolbars: (state) => { return state.mdEditorToolbars; },
  // getCustomRender: (state)=>{ return customRender; },
};
const mutations = {

};
const actions = {

};
export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};
